import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ZkNotificationService } from '@zenklub/ng-ui';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { ITaxonomy } from 'app/interfaces/search.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { TaxonomyService } from 'app/services/taxonomy.service';
import { AppointmentService } from 'shared/services/appointment/appointment.service';

@Component({
	selector: 'promptuary-reasons',
	templateUrl: './promptuary-reasons.component.html',
	styleUrls: ['./promptuary-reasons.component.scss'],
})
export class PromptuaryReasonsComponent implements OnInit, OnChanges {
	@Input() type = 'sidebar';
	@Input() formField: FormControl;
	@Input() appointmentId;
	@Input() initialValue = [];
	@Input() readonly = false;

	@Output() onSaving = new EventEmitter<any>();
	@Output() onSaved = new EventEmitter<any>();

	isReady = false;
	isReasonsSugestionOpen = true;
	taxonomyList: ITaxonomy[];
	_value: string[] = [];
	_options: { label: string; value: string }[];
	_lastAppointmentReasons: any[] = [];
	constructor(
		public taxonomyService: TaxonomyService,
		public appointmentService: AppointmentService,
		public notificationService: ZkNotificationService,
		public translateService: TranslateService,
		public atService: ActionTrackerService
	) {}

	ngOnInit(): void {
		this.taxonomyService
			.getTaxonomyList('reason')
			.toPromise()
			.then((result) => {
				this.taxonomyList = result;
				this._options = result.map((item) => {
					return { label: item.name, value: item.id };
				});
				this._value = this.initialValue ? this.initialValue : [];
				this.isReady = true;
			});
		if (!this.readonly) {
			this.appointmentService
				.getLastReasonsForAppointment(this.appointmentId)
				.toPromise()
				.then((reasons) => {
					this._lastAppointmentReasons = reasons
						?.map((reason) => {
							return { label: reason.name['pt-BR'], value: reason.id };
						})
						?.filter((reason) => {
							return !this.initialValue?.find(
								(value) => value === reason.value
							);
						});
				});
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.initialValue) {
			this._lastAppointmentReasons = this._lastAppointmentReasons?.filter(
				(reason) => {
					return !this.initialValue?.find((value) => value === reason.value);
				}
			);
		}
	}

	addReason(id) {
		const item = this.taxonomyList.find((taxonomyItem) => {
			return taxonomyItem.id === id;
		});
		if (item) {
			if (this._value?.length >= 6) {
				this.notificationService.showError(
					this.translateService.instant('SCHEDULE.REASONS.MAX_6_REASONS')
				);
				return;
			}
			this._value = [...this._value, id];
			this._lastAppointmentReasons = this._lastAppointmentReasons.filter(
				(reason) => {
					return reason.value !== id;
				}
			);
			this.updateAppointmentReasons();
			this.atService.eventTracker(
				SCOPE_TYPE.Promptuary,
				SUBSCOPE_TYPE.Session,
				ITEM_TYPE.ReasonSugestion,
				INTERACTION_TYPE.Click,
				{}
			);
		}
	}

	onChangeReasons(reasons) {
		const value = reasons.value;
		if (value.length > 6) {
			this.notificationService.showError(
				this.translateService.instant('SCHEDULE.REASONS.MAX_6_REASONS')
			);
			this._value.pop();
			return;
		}

		if (value.length === 0) {
			this.notificationService.showError(
				this.translateService.instant('SCHEDULE.REASONS.AT_LEAST_ONE_REASON')
			);
			this._value.push(reasons.itemValue);
			return;
		}

		this._value = value;
		this.updateAppointmentReasons();
	}

	updateAppointmentReasons() {
		this.formField.setValue(this._value);
		this.onSaving.emit();
		this.appointmentService
			.setSessionReasons(this.appointmentId, this._value)
			.toPromise()
			.then(() => {
				this.onSaved.emit();
			})
			.catch(({ error }) => {
				this.notificationService.showError(error.messageI18n);
			});
	}
}
